import React, { useContext } from 'react'
import { ShopContext } from '../Context/ShopContext'
import { useParams } from 'react-router-dom'
import Breadcrum from '../Components/Breadcrums/Breadcrum'
import ProductDisplay from '../Components/ProductDisplay/ProductDisplay'

const Product = () => {
  const {all_product} = useContext(ShopContext);
  const {productId} = useParams();
  const product = all_product.find((e)=> e.id === Number(productId));

  return (
    <div>
      <Breadcrum product={product} />
      <ProductDisplay product={product} />

      {product.category !== "accounts" && (
  <div className="product-assurance">
        <div className="assurance-item">
          <h3>NO ID PASSWORD REQUIRED</h3>
          <p>Your account details are never required.</p>
        </div>

        <div className="assurance-item">
          <h3>COMPLETELY SAFE</h3>
          <p>Secure and safe purchase process.</p>
        </div>

        <div className="assurance-item">
          <h3>FULLY CLAIMABLE</h3>
          <p>Your VP is fully claimable.</p>
        </div>

                <div className="assurance-item">
          <h3>TRANSACTION ID & INVOICE</h3>
          <p>Complete transaction details are provided.</p>
        </div>
      </div>
      )}

    </div>
  )
}

export default Product